module.exports = __webpack_public_path__ + "static/media/img_redemption_code.a533e84f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_redemption_code.svg
// module id = 388
// module chunks = 0